import React from 'react'
import home from "../../Assets/Images/home.avif";

const SecondaryHeader = ({
  pageHeading,
  breadcomb,
  overlayOpacity = 0.4,
  minHeight = "250px"
}) => {
  return (
    <div 
      className="relative w-full bg-center bg-cover bg-no-repeat flex items-center justify-center text-white"
      style={{ 
        backgroundImage: `url(${home})`,
        minHeight: minHeight
      }}
    >
      {/* Overlay with customizable opacity */}
      <div 
        className="absolute inset-0 bg-black transition-opacity duration-300"
        style={{ opacity: overlayOpacity }}
        aria-hidden="true"
      />
      
      {/* Content */}
      <div className="relative z-10 text-center space-y-4 px-4 w-full max-w-6xl mx-auto">
        {/* Page Heading */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight drop-shadow-lg">
          {pageHeading}
        </h1>
        
        {/* Breadcrumb */}
        <div className="flex items-center justify-center text-sm sm:text-base md:text-lg font-medium text-white/90 drop-shadow-md">
          {breadcomb}
        </div>
      </div>

      {/* Optional gradient overlay for better text readability */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.4) 100%)'
        }}
        aria-hidden="true"
      />
    </div>
  )
}

export default SecondaryHeader